export default {
  save: 'Save',
  start: 'Start',
  confirm: 'Confirm',
  disable: 'Disable'
}
